export class EFormSurveyAnswer {
    ID: number;
    FormID: number;
    SurveyFieldID: number;
    Answer: string;
    AddedOn: Date;
    AddedBy: number;
    LastUpOn: Date;
    LastUpBy: number;
    IsCritical: boolean;
   }